import { Paragraph3 } from '@cian/ui-kit';

import * as React from 'react';

export const CADASTRAL_NUMBER_TOOLTIP_TEXT = (
  <div>
    <Paragraph3>Номер в формате 47:14:1203001:814.</Paragraph3>
    <Paragraph3>Указан в Свидетельстве о собственности.</Paragraph3>
  </div>
);
